import RowContent from '../RowContent'
import XmarkIcon from '@ui-components-3/icons/lib/regular/Xmark'
import CheckIcon from '@ui-components-3/icons/lib/regular/Check'

import { ReactNode, useMemo } from 'react'
import classNames from '@ui-components-3/ui/lib/utils/classNames'

type RowProps = {
  content: ReactNode
  required: boolean
  incompleteMessage: string
  label: string
  showCompleteIcon?: boolean
}

const Row = ({ content, required, showCompleteIcon, incompleteMessage = '', label }: RowProps) => {
  const Icon = useMemo(() => (content ? CheckIcon : XmarkIcon), [content])

  return (
    <div className="flex mb-6">
      <div className="min-w-[40px]">
        {(!!required || (!!content && !!showCompleteIcon)) && (
          <Icon
            aria-hidden="true"
            className={classNames('w-6 h-6 mt-0.5', content ? 'text-neutral-500' : 'text-fuchsia-800')}
          />
        )}
      </div>

      <RowContent content={content} incompleteMessage={incompleteMessage} label={label} />
    </div>
  )
}

export default Row
